// Module
var code = `<template> <div class="dialog-question-info dialog-wrap"> <div class="dialog-header row align-items-middle"> <h3 class="dilaog-title col">\${title}</h3> </div> <div class="dialog-content"> <pre class="info" innerhtml.bind="moreInfo | htmlSanitize"></pre> </div> </div> </template>`;
// Exports
module.exports = code;